import getColor from "@insite/mobius/utilities/getColor";
import { categoriesStyles } from "@waytek/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
    globalGuardianBlue: getColor("common.global.guardianBlue"),
};

categoriesStyles.container = {
    ...categoriesStyles.container,
    css: css`
        margin-top: 40px;
    `,
};

categoriesStyles.title = {
    ...categoriesStyles.title,
    as: "h3",
    variant: "h6",
    css: css`
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.78;
        letter-spacing: normal;
        border-bottom: 3px solid ${localColors.globalIndustrialTaupe};
        padding-bottom: 4px;
        margin-bottom: 20px;
    `,
};

categoriesStyles.categoryNameLinkItem = {
    ...categoriesStyles.categoryNameLinkItem,
    css: css`
        &&& {
            padding-bottom: 0;
        }
    `,
};

categoriesStyles.categoryNameLink = {
    ...categoriesStyles.categoryNameLink,
    css: css`
        &&& {
            span {
                color: ${localColors.globalGuardianBlue};
                font-weight: bold;
                text-decoration: none;
                border: 0;

                &:hover {
                    text-decoration: underline;
                    border: 0;
                }
            }
        }
    `,
};

categoriesStyles.subCategoryItem = {
    ...categoriesStyles.subCategoryItem,
    css: css`
        &&& {
            margin-bottom: 10px;
        }
    `,
};

categoriesStyles.subCategoryLink = {
    ...categoriesStyles.subCategoryLink,
    css: css`
        margin-left: 10px;

        ${mediaQueriesBP.maxMD} {
            margin-left: 0;
        }
    `,
};
